/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { ListeContainer, useListe } from '@mairistem/liste';

import type { SituationScolaire } from '@/types';

import SituationScolaireListe from './SituationScolaireListe';

interface Props {
  /** Callback appelé lors de la sauvegarde d'une ligne (liste en saisie) */
  onSave?: (qualification: SituationScolaire) => void;
  /** Callback appelé lors de la sélection d'une ligne */
  onSelect?: (qualification: SituationScolaire) => void;
  /** Situation scolaire sélectionnée */
  selectedItem?: SituationScolaire;
  /** Réinitialisation des lignes */
  resetSelectedItem?: () => void;
}

const SituationScolaireListeContainer = (props: Props) => {
  const {
    selectedItem = {},
    onSave = null,
    onSelect = null,
    resetSelectedItem = null,
  } = props;

  const [service] = useListe(
    '/api/administres/recensement-citoyen/situations-scolaires',
  );

  return (
    <ListeContainer
      service={service}
      type="situationsScolaires"
      contains="liste"
      perPage={50}
    >
      <SituationScolaireListe
        onSave={onSave}
        onSelect={onSelect}
        selectedSituationScolaire={selectedItem}
        resetSelectedItems={resetSelectedItem}
      />
    </ListeContainer>
  );
};

export default SituationScolaireListeContainer;
